export default __webpack_public_path__ + "static/media/reload.5bfdad3c.svg";